var data = {
	"body": "<g fill=\"currentColor\"><path d=\"M17 13.13v3.697h-2.143v-3.45c0-.866-.31-1.457-1.086-1.457c-.592 0-.945.398-1.1.784c-.056.138-.071.33-.071.522v3.601h-2.144s.029-5.842 0-6.447H12.6v.913l-.014.021h.014v-.02c.285-.44.793-1.066 1.932-1.066c1.41 0 2.468.922 2.468 2.902zM8.213 7.271C7.48 7.271 7 7.753 7 8.385c0 .62.466 1.115 1.185 1.115h.014c.748 0 1.213-.496 1.213-1.115c-.014-.632-.465-1.114-1.199-1.114zm-1.086 9.556h2.144V10.38H7.127v6.447z\"/><path d=\"M12 20a8 8 0 1 0 0-16a8 8 0 0 0 0 16zm0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10z\"/></g>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
